import { useContext } from "react";
import State from "../../../../../../context";
import { Button, Flex } from "antd";
import ChartSkeleton from "../../../../../../atom/ChartSkeleton";
import ModalLevelProductDetails from "../../../admin/component/ModalLevelProductDetails";
import ProposalGoalPreviewGrowth from "../ProposalGoalPreviewGrowth";
import ProposalGoalPreviewIncome from "../ProposalGoalPreviewIncome";

import { getValidProductId } from "../../helper";

const ViewAllGoal = ({ handleDownloadProposal, handleViewGoal }) => {
  const [state] = useContext(State);

  const productMap = state.getPreferenceValue("productMap");

  const ProposalGoalFooter = ({ goalId }) => (
    <Flex justify="center">
      <Button onClick={() => handleViewGoal(goalId)} shape="round">
        View Proposal
      </Button>
    </Flex>
  );

  return (
    <>
      <ChartSkeleton active loading={state.loading}>
        <Flex align="stretch" gap={32}>
          {Object.keys(productMap).map(goalId => {
            const proposalData =
              productMap[goalId][productMap[goalId].length - 1];

            const validProductId = getValidProductId({
              organization: state.organization?.name,
              productsList: state.productsList,
              proposalProductId: proposalData.productId,
              proposalRiskTolerance: proposalData.riskTolerance?.toLowerCase(),
            });

            const productData = state.productsList?.find(
              it => it._id === validProductId
            );

            return proposalData?.investmentObjective === "growth" ? (
              <ProposalGoalPreviewGrowth
                Footer={() => <ProposalGoalFooter goalId={goalId} />}
                handleDownloadProposal={() => handleDownloadProposal(goalId)}
                key={goalId}
                proposalData={{
                  ...proposalData,
                  productId: validProductId,
                }}
                productData={productData}
              />
            ) : (
              <ProposalGoalPreviewIncome
                Footer={() => <ProposalGoalFooter goalId={goalId} />}
                handleDownloadProposal={() => handleDownloadProposal(goalId)}
                key={goalId}
                proposalData={{
                  ...proposalData,
                  productId: validProductId,
                }}
                productData={productData}
              />
            );
          })}
        </Flex>
      </ChartSkeleton>

      <ModalLevelProductDetails
        handleClose={() => state.setKeyValue("openModalProductDetails", false)}
        investmentAssumptions={state.investmentAssumptions}
        open={state.openModalProductDetails}
        product={state.productsList?.find(
          it => it._id === state.productDetailsId
        )}
        showError={state.showError}
      />
    </>
  );
};

export default ViewAllGoal;
